import { DOCUMENT } from '@angular/common';
import { HttpBackend } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@aspnet/signalr';
import { SignaturePad } from 'ngx-signaturepad';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
const FileSaver = require('file-saver');

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}


@Component({
  selector: 'app-portal-ui',
  templateUrl: './portal-ui.component.html',
  styleUrls: ['./portal-ui.component.scss']
})
export class PortalUIComponent implements OnInit {

  isDashboard = true;
  broadcastMessage = false;
  detail = false;


  spinner: boolean = false;
  ResponseHolderDetails:any;
  activities:any=[]=[];
  broadCastList:any=[]=[];
  TopbroadCast:string="";
  notesList:any=[]=[];
  TopbroadCastList:any=[]=[];
  broadcastings:any=[]=[];
  contacts:any=[]=[];
  forms:any=[]=[];
  PortalFormsforHome:any=[]=[];
  waitingActions:any=[]=[];
  AllwaitingActions:any=[]=[];
  stateCtrlValue: string;

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  objectList: any = [];

  selectedCore:any;
  coreDropdownList:any=[]=[];
  timeout = null;
  portalEmail:string="";
  officeLogo:string="";
  portalName:string="";
  pageIndexActivity:number=10;

  personID:number=0;
  totalActivities:number=0;
  totalWaitingActions:number=0;
  totalBroadcastings:number=0;
  totalContacts:number=0;
  totalForms:number=0;
  totalNotes:number=0;
  totalPortalFormsforHome:number=0;

  id:any;
  selectedPersonId:any;
  myDate = Date.now();   
 
  // Notes  //
  PersonalChecked:boolean=true;
  GlobalChecked:boolean=false;
  addNotesForm: FormGroup;
  selectedColor: string = "";
  showColorDrp:boolean=true;
  responseHolder: any;
  noteLevel:number=2;
  noteLevelType:number=0;
  NotesList: any[] = [];
  showNotesList:boolean=true;
  noteType:string="0";
  notes:string="";
  color:string="";
  noteID:number=0;
  maxChars=350;
  addnotes:number=0;
  savebuttonshow:boolean=false;
  officeID:number=0;
  organizationID:number=0;

  allBroadCastList:any=[]=[];

  coreDetailDocumentList:any=[]=[];
  coreDetailActivityList:any=[]=[];
  coreDetailWaitingActionsList:any=[]=[];

  col = [
    {
     colname:'#F5D428'     
   },
   {
     colname:'#6FC040'
   },
   {
     colname:'#52A7F9'
    },
    {
      colname:'#EF8F1E'
    },
    {
     colname:'#EC5C58'
    },
    {
      colname:'#B36AE2'
    },
 ]

 cType:number=0;

 fontSize=[
  { fontsize:7 },
  { fontsize:8 },
  { fontsize:9 },
  { fontsize:10 },
  { fontsize:11 },
  { fontsize:12 },
  { fontsize:14 },
  { fontsize:16 },
  { fontsize:18 },
  { fontsize:20 },
  { fontsize:22 },
  { fontsize:24 },
  { fontsize:26 },
  { fontsize:28 },
  { fontsize:36 },
  { fontsize:48 },
  { fontsize:72 }
]

family = [
  {font: 'Architects Daughter, cursive'},
  {font: 'Dancing Script, cursive'},
  {font: 'Pacifico, cursive'},
  {font: 'Satisfy, cursive'},
  {font: 'Caveat, cursive'},
  {font: 'Cookie, cursive'},
  {font: 'Great Vibes, cursive'},
  {font: 'Parisienne, cursive'},
  {font: 'Sacramento, cursive'},
  {font: 'Yellowtail, cursive'},
  {font: 'Alex Brush, cursive'},
  {font: 'Allura, cursive'},
  {font: 'Damion, cursive'},
  {font: 'Homemade Apple, cursive'},
  {font: 'Leckerli One, cursive'},
  {font: 'Mr Dafoe, cursive'},
  {font: 'Nothing You Could Do, cursive'},
  {font: 'Pinyon Script, cursive'},
  {font: 'Tangerine, cursive'},
  {font: 'Cedarville Cursive, cursive'},
  {font: 'Grand Hotel, cursive'},
  {font: 'Herr Von Muellerhoff, cursive'},
  {font: 'Italianno, cursive'},
  {font: 'Kristi, cursive'},
  {font: 'Niconne, cursive'},
  {font: 'Norican, cursive'},
  {font: 'Petit Formal Script, cursive'},
  {font: 'Rochester, cursive'},
  {font: 'Bilbo Swash Caps, cursive'},
  {font: 'Clicker Script, cursive'},
  {font: 'Dawning of a New Day, cursive'},
  {font: 'Euphoria Script, cursive'},
  {font: 'Ma Shan Zheng, cursive'},
  {font: 'Mr De Haviland, cursive'},
  {font: 'Qwigley, cursive'},
  {font: 'Sofia Script, cursive'},
  {font: 'The Girl Next Door, cursive'},
  {font: 'Zeyada, cursive'},
  {font: 'Beth Ellen, cursive'},
  {font: 'Charmonman, cursive'},
  {font: 'Devonshire, cursive'},
  {font: 'Dr Sugiyama, cursive'},
  {font: 'Engagement, cursive'},
  {font: 'League Script, cursive'},
  {font: 'Meie Script, cursive'},
  {font: 'Mr Bedfort, cursive'},
  {font: 'Romanesco, cursive'},
  {font: 'Stalemate, cursive'},
  {font: 'Zhi Mang Xing, cursive'},
]  

fontfamilys = [
  {font: 'Arail'},
  {font: 'Calibri'},
  {font: 'Roboto'},
  {font: 'Tahoma'},
  {font: 'Verdana'},
] ;
link = [
  'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
  'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
  'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
  'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
  'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
];

 SignButtonEnable:boolean=false;
 DrawButtonEnable:boolean=false;
 InitailButtonEnable:boolean=false;
 reasonToDecline:string="";
 declineButtonShow:boolean=false;
 @ViewChild(SignaturePad) signaturePad: SignaturePad;
 signOpt: string = 'draw';
 hasSignature:boolean = false;
 getAllSignatures:any=[]=[];
 signatureID:number=0;
 signatureData:any;
 fiveSignaturesLimitReached:boolean=true;
 participantEmailId:any;
 dialogueRef:any;
 signatureBase64: string="";
 signName: string;
 signOrInitialImageObj: any=[]=[];
 signInitialFontFamily: any;
 Imageurl:any;
 filenameForSign = "";
 selected:any;

 signaturePadOptions: any = { 
  'minWidth': 2,
  'canvasWidth': 822,
  'canvasHeight': 150,
  'penColor':"blue"
 };
 backgroundImage:string="";

  constructor(private dialog: MatDialog, private router: Router,
     private formsService: FormsService, private loaderService: LoaderService,
     private toastr: ToastrService, private reusableClass: ReusableClasses,
     private statusConstant: StatusConstant, private encryptionAlgo: EncryptionService,
     private formBuilder: FormBuilder,private sanitizer: DomSanitizer,
     @Inject(DOCUMENT) private document: Document) {    

      // this.stateCtrl.setValue(this.stateCtrlValue);
      // this.filteredStates = this.stateCtrl.valueChanges.pipe(
      //   startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
      // );
   }

  ngOnInit(): void {
    this.CheckLoginTokenEXpiry();
    this.portalEmail = sessionStorage.getItem("portalemail");
    if(this.portalEmail!=null && this.portalEmail!=undefined && this.portalEmail!="" && this.portalEmail.length>0){
      let toArray =  this.portalEmail.split("@");
      this.portalName = toArray[0];
    }else{
      //sessionStorage.removeItem('LoginToken')
     // sessionStorage.removeItem('portalemail')
      sessionStorage.removeItem('LoginToken');
      sessionStorage.removeItem('portalemail');
      this.router.navigate([`/auth/portallogin`]);
      return;
    }
    
    this.document.body.classList.add('portal');
    this.getPortalDataforHome();
    this.getPortalFormsforHome();
    this.getPortalUser3Cs('');
    this.ShowAllSignature();
    this.getPortalBroadcastingMessages();
  }

  getPortalDataforHome(){
    var ReqModel = {    
      email: this.portalEmail,//record.email,     
    }; 
    this.spinner = true;
    this.formsService.getPortalDataforHome(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   

          this.activities= this.ResponseHolderDetails.data.activities;
          if(this.activities!=null){
            this.totalActivities= this.activities.length;
            //this.activities = this.activities.slice(0,5)
          }else{
            this.activities=[];
            this.totalActivities=0;
          }         

          this.broadcastings= this.ResponseHolderDetails.data.broadcastings;
          if(this.broadcastings.length>0){
            this.totalBroadcastings= this.broadcastings.length;
            //this.broadcastings = this.broadcastings.slice(0,5)
          }else{
            this.broadcastings=[];
            this.totalBroadcastings=0;
          }          

          this.contacts= this.ResponseHolderDetails.data.contacts;         
          if(this.contacts.length>0){
            this.totalContacts= this.contacts.length;
            //this.contacts = this.contacts.slice(0,5)
          }else{
            this.contacts=[];
            this.totalContacts=0;
          }

          this.forms= this.ResponseHolderDetails.data.forms;
          if(this.forms!=null){
            this.totalForms= this.forms.length;
            //this.forms = this.forms.slice(0,5)
          }else{
            this.forms=[];
            this.totalForms=0;
          }      

          this.notesList = this.ResponseHolderDetails.data.notes;
          if(this.notesList!=null){
            this.totalNotes = this.notesList.length;
            //this.notesList = this.notesList.slice(0,5)
          }else{
            this.notesList=[];
            this.totalNotes =0;
          }        
         
          this.waitingActions= this.ResponseHolderDetails.data.waitingActions;
          if(this.waitingActions!=null){
            this.totalWaitingActions= this.waitingActions.length;
            //this.waitingActions = this.waitingActions.slice(0,10)
          }else{
            this.waitingActions=[];
            this.totalWaitingActions=0;
          }    
        
          this.spinner = false;
        } else {        
          this.spinner = false;
        }
      } else {       
        this.spinner = false;
      }
    });
  }

  getPortalFormsforHome(){
    var ReqModel = {    
      email: this.portalEmail,//record.email,     
    }; 
    this.spinner = true;
    this.formsService.getPortalFormsforHome(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
         this.spinner = false;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   
          this.PortalFormsforHome= this.ResponseHolderDetails.data.forms;
          if(this.PortalFormsforHome!=null){
            this.totalPortalFormsforHome= this.PortalFormsforHome.length;
          }else{
            this.PortalFormsforHome=[];
            this.totalPortalFormsforHome=0;
          }     
          this.spinner = false;
        } else {        
          this.spinner = false;
        }
      } else {       
        this.spinner = false;
      }
    });
  }

  getPortalBroadcastingMessages(){
    var ReqModel = {    
      email: this.portalEmail,//record.email,     
    }; 
    this.spinner = true;
    this.formsService.getPortalUnreadNotifications(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
        this.spinner = false;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   

          this.broadCastList= this.ResponseHolderDetails.data;
          if(this.broadCastList.length>0){
            this.TopbroadCast=this.broadCastList[0].title;
            this.TopbroadCastList=this.broadCastList[0];
          }else{
            this.broadCastList=[];
          }         
                
          this.spinner = false;
        } else {        
          this.spinner = false;
        }
      } else {       
        this.spinner = false;
      }
    });
  }

  getPortalAllBroadcastingMessages(){
    var ReqModel = {    
      email: this.portalEmail,//record.email,     
    }; 
    this.spinner = true;
    this.formsService.getPortalBroadcastingMessages(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
        this.spinner = false;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {
          this.allBroadCastList= this.ResponseHolderDetails.data;
          if(this.allBroadCastList.length>0){
            this.allBroadCastList.map(e => {
              if (e.message.length > 0) {               
                e.desc = e.message.replace(/<[^>]*>/g, '').slice(0,100);
                e.desc = e.desc.replace(/\&nbsp;/g, '');               
              }
            });
          }else{
            this.allBroadCastList=[];
          }                
          this.spinner = false;
        } else {        
          this.spinner = false;
        }
      } else {       
        this.spinner = false;
      }
    });
  }

  CheckLoginTokenEXpiry(){
    if(sessionStorage.getItem('LoginToken')!=null && sessionStorage.getItem('LoginToken')!=undefined){
       var reqModel={
         email: sessionStorage.getItem('portalemail')
       };
       this.loaderService.show();
       this.spinner=true;
       this.formsService.CheckLoginTokenEXpiry(reqModel).subscribe(response => {
       let  responseHolder:any;
       responseHolder=response;
         if (responseHolder.data) {
           responseHolder = response;
           this.toastr.warning("Login token expired", '', {
             timeOut: 3000,
           });
           this.loaderService.hide();
           this.spinner=false;
           sessionStorage.removeItem('LoginToken');
           sessionStorage.removeItem('portalemail');
           this.router.navigate([`/auth/portallogin`]);
         }
       });
   } 
}

getCompletedActionsfor3C() {
  var ReqModel = {
    cid: this.personID,
    cType: this.cType,
    email: this.portalEmail,
    officeID: this.officeID,
    organizationID:  this.organizationID
  }; 
  this.spinner=true;
  this.formsService.getCompletedActionsfor3C(ReqModel).subscribe((response) => {
    if(response != undefined) {
      this.ResponseHolderDetails = response;
      this.spinner=false;
      if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   
     
        this.coreDetailActivityList= this.ResponseHolderDetails.data.activities;
         if(this.coreDetailActivityList!= null){
            //this.totalActivities= this.activities.length;
           // this.activities = this.activities.slice(0,5)
           this.coreDetailActivityList.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
            } 
            if(res.createdByLastName == null && res.createdByLastName == null && res.byPortal==null){
              res.createdByFirstName = "Anonymous";
            }           
            return res;
          });

          }else{
            this.coreDetailActivityList=[];
          }  

          this.coreDetailDocumentList= this.ResponseHolderDetails.data.documents;
          if(this.coreDetailDocumentList.length>0){
             //this.totalActivities= this.activities.length;
            // this.activities = this.activities.slice(0,5)
           }else{
             this.coreDetailDocumentList=[];
          }  

          this.coreDetailWaitingActionsList= this.ResponseHolderDetails.data.waitingActions;
          if(this.coreDetailWaitingActionsList!=null){
             //this.totalActivities= this.activities.length;
            // this.activities = this.activities.slice(0,5)
           }else{
             this.coreDetailWaitingActionsList=[];
          }
      }else {
        this.spinner=false;
      }
    }else{
      this.spinner=false;
    }
   });
 }


  getPortalUser3Cs(val) {
    this.spinner=true;
    //this.loaderService.show();
    var ReqModel = {
      email: this.portalEmail,
      searchKeyword: val,
      token: null
    };  
    this.formsService.getPortalUser3Cs(ReqModel).subscribe((response) => {
      if(response != undefined) {        
        this.spinner=false;
        this.ResponseHolderDetails = response;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   
         this.coreDropdownList= this.ResponseHolderDetails.data;
         if(this.coreDropdownList.length>0){
        //   this.coreDropdownList = this.coreDropdownList.map((x) => ({
        //    name: x.name,
        //    officeName: x.officeName,
        //    personID:x.personID,
        //    officeID:x.officeID,
        //    organizationID:x.organizationID,
        //    officeLogo:x.officeLogo,
        //    cType:x.cType,
        //    token:x.token,
        //    email: x.email
        //  }));       
        }   
        } else {            
          this.spinner=false;       
        }
      } else {          
        this.spinner=false;      
      }
    });
  }


  selectPeoples(record: any){
    
    this.isHome=true;

    if(this.currentNavigation=="detail"){
      this.currentNavigation="detail";
    }else{
      this.currentNavigation = "dashboard";
    }   
    
    if(record==null){
      this.personID;
      this.officeID;
      this.organizationID;
      //this.officeLogo;
      this.cType
    }else{
      var find=[];
      find = this.coreDropdownList.filter(x=>x.personID==record);     
      this.personID = find[0].personID; //record.personID;
      this.officeID = find[0].officeID;//record.officeID;
      this.organizationID = find[0].organizationID;//record.organizationID;
      this.officeLogo= find[0].officeLogo;//record.officeLogo;
      this.cType = find[0].cType;//record.cType;
      this.backgroundImage = find[0].backgroundImage;
    }  
    if(this.detail==true){
      this.getCompletedActionsfor3C();
      return;
    }   
    
    var ReqModel = {
      cid: this.personID,
      cType: this.cType,
      email: this.portalEmail,//record.email,
      //token: "",
      officeID: this.officeID,
      organizationID:  this.organizationID
    }; 
   
    this.spinner = true;
    this.formsService.getPortalDatafor3C(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   

          this.activities= this.ResponseHolderDetails.data.activities;
          if(this.activities!=null){
            this.totalActivities= this.activities.length;
            this.activities.map((res) => {
              if (res.createdByFirstName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
              } 
              if(res.createdByLastName == null && res.createdByLastName == null && res.byPortal==null){
                res.createdByFirstName = "Anonymous";
              }           
              return res;
            });
            //this.activities = this.activities.slice(0,5)
          }else{
            this.activities=[];
            this.totalActivities=0;
          }         

          this.broadcastings= this.ResponseHolderDetails.data.broadcastings;
          if(this.broadcastings.length>0){
            this.totalBroadcastings= this.broadcastings.length;
            //this.broadcastings = this.broadcastings.slice(0,5)
          }else{
            this.broadcastings=[];
            this.totalBroadcastings=0;
          }          

          this.contacts= this.ResponseHolderDetails.data.contacts;         
          if(this.contacts.length>0){
            this.totalContacts= this.contacts.length;
            //this.contacts = this.contacts.slice(0,5)
          }else{
            this.contacts=[];
            this.totalContacts=0;
          }

          this.forms= this.ResponseHolderDetails.data.forms;
          if(this.forms!=null){
            this.totalForms= this.forms.length;
            this.forms.map((res) => {
              if (res.createdByFirstName != null) {
                if(res.createdByFirstName !='Anonymous'){
                  res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
                }               
              }
              if (res.createdByLastName != null) {
                if(res.createdByLastName !='Anonymous'){
                  res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
                }                
              } 
              if(res.createdByLastName == null && res.createdByLastName == null){
                res.createdByFirstName = "Anonymous";
              }           
              return res;
            });
            //this.forms = this.forms.slice(0,5)
          }else{
            this.forms=[];
            this.totalForms=0;
          }      

          this.notesList = this.ResponseHolderDetails.data.notes;
          if(this.notesList!=null){
            this.totalNotes = this.notesList.length;
           // this.notesList = this.notesList.slice(0,5)
          }else{
            this.notesList=[];
            this.totalNotes =0;
          }        
         
          this.waitingActions= this.ResponseHolderDetails.data.waitingActions;
          if(this.waitingActions!=null){
            this.totalWaitingActions= this.waitingActions.length;
            //this.waitingActions = this.waitingActions.slice(0,10)
          }else{
            this.waitingActions=[];
            this.totalWaitingActions=0;
          }        
          this.spinner = false;
        } else {        
          this.spinner = false;
        }
        //this.getCompletedActionsfor3C();
      } else {       
        this.spinner = false;
      }
    });
  }

  
  showActivity() {
    var number=0;
    number =(number+this.pageIndexActivity);
    this.pageIndexActivity= (number+10);   

    if(this.AllwaitingActions.length>0){
      this.waitingActions = this.AllwaitingActions.slice(0,this.pageIndexActivity)
    }   
  }

  
  openLink(data:any){
    let URL= data.url+"&access="+'portal'+"&email="+this.portalEmail+"";
    window.open(URL, '_blank');

    // if(data.aType!=8){
    //   let URL =data.url;// window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
    //   window.open(URL, '_blank');
    // }else{
    //   let URL= data.url+"&access="+'portal'+"&email="+this.portalEmail+"";
    //   //let URL =data.url+"&access=portal&emailId=";// window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
    //   window.open(URL, '_blank');
    // }   
  }

  openForm(data:any){
    const tokenm = this.encryptionAlgo.set(this.reusableClass.encryptionKey, data.token);
    let encodedtoken = encodeURIComponent(tokenm);

    let URL= window.location.origin+"/request/projectFromFormLink?"+"token="+encodedtoken+"&access="+'portal'+"&email="+this.portalEmail+"";
    window.open(URL, '_blank');


   //let URL =data.url;// window.location.href.split(window.location.pathname)[0] + "/request/task?token=" + encryptedTokenWithEncoding;
   // window.open(URL, '_blank');
  }


  onAddNoteCharCheck(textValue: string): void {
    if(textValue!=null || textValue!=undefined){
     this.addnotes = textValue.length;
    }
  }

  
   addNotes(data, templateRef: TemplateRef<any>) {
    this.addNotesForm = this.formBuilder.group({
      notes: ['', Validators.required],
      color: ['', Validators.required]
    });
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });
    this.noteID=0;
    this.addnotes=0;
    this.selectedColor="#F5D428";
    this.noteLevel=2;
    this.PersonalChecked=true;
    this.GlobalChecked=false;
    this.showColorDrp=true;
    this.savebuttonshow=false;
    this.addNotesForm.patchValue({
      color: "#F5D428"
    });

    if(data != 'new'){
      this.noteID = data.noteID;
      this.addNotesForm.get('notes').setValue(data.note);
      this.addNotesForm.get('color').setValue(data.color)
    }
    
   }


   logout(){
    sessionStorage.removeItem('LoginToken');
    sessionStorage.removeItem('portalemail');
    this.router.navigate([`/auth/portallogin`]);
    window.location.reload();
   }

    // add/update notes // 
    AddNotes(formValues){
      if(this.currentNavigation =='home'){
        this.adNoteForDashboard(formValues);
      }else{
       // this.adNoteForSelectedCore(formValues);
      }
      //  if( this.personID>0){
      //   this.adNoteForSelectedCore(formValues);
      // }else{
      //   this.adNoteForDashboard(formValues);
      // }     
    }


    removeNote(notes) {
      const message = `Are you sure you want to delete this note?`;
      const title = `Confirm Delete`;
      const confirm = `Delete`;
      const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {        
            if (notes !== undefined) {
              var ReqModel = {
                noteID: notes.noteID,
                byPortal:this.portalEmail,
                // userID: "0262a759-80f6-46bc-9cfc-560c7dc1c50e",
                // organizationID: Number(this.organizationID),
                // officeID:this.officeID,      
              }  
              this.formsService.deletePortalNotes(ReqModel).subscribe((response) => {
                if (response != undefined) {
                  this.responseHolder = response;
                  if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                    this.getPortalDataforHome();
                    this.toastr.success('Note delete successfully.', '', {
                      timeOut: 3000,
                    });
                  }else{
                    
                  }
                } else {
                  
                }
              });
            }
          }
        } catch (e) {
          Observable.throw(e);
        }
      });
     }
  

    adNoteForDashboard(formValues){    
      var ReqModel = {
        noteID: this.noteID,
        noteLevelID: 3, // 1- Global, 2- Personal , 3-Portal
        note: formValues.notes,
        color: formValues.color,
        userID: "0262a759-80f6-46bc-9cfc-560c7dc1c50e",
        email:this.portalEmail,
        byPortal:this.portalEmail,
        organizationID: Number(this.organizationID),
       // databaseID: Number(this.databaseId),
        officeID:this.officeID,       
       } 
       this.spinner=true;
       this.savebuttonshow=true;
       this.formsService.addPersonalNotePortal(ReqModel).subscribe(response=>{
        if (response != undefined) {
          this.spinner=false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {           
              this.toastr.success('Note added successfully.', '', {
                timeOut: 3000,
              });
              if(this.currentNavigation =='home'){
                this.getPortalDataforHome();
              }else{
                this.selectPeoples(null); 
              }                           
           this.close();
          }
        }else{
          this.spinner=false;
        }
       });
    }

    adNoteForSelectedCore(formValues){
      var ReqModel = {
        noteID: this.noteID,
        noteLevelID: 3, // 1- Global, 2- Personal , 3-Portal
        note: formValues.notes,
        color: formValues.color,
        userID: "0262a759-80f6-46bc-9cfc-560c7dc1c50e",
        email:this.portalEmail,
        byPortal:this.portalEmail,
        organizationID: Number(this.organizationID),
       // databaseID: Number(this.databaseId),
        officeID:this.officeID,       
       } 
       this.spinner=true;
       this.savebuttonshow=true;
       this.formsService.addNote(ReqModel).subscribe(response=>{
        if (response != undefined) {
          this.spinner=false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {           
              this.toastr.success('Note added successfully.', '', {
                timeOut: 3000,
              });
              if(this.personID>0){
                this.selectPeoples(null); 
              }else{ 
                this.getPortalDataforHome();
              }             
           this.close();
          }
        }else{
          this.spinner=false;
        }
       });
    }

   close() {
    this.savebuttonshow=false;
    this.noteID=0;
    this.selectedColor="";   
    this.addnotes=0;
    this.addNotesForm.reset();
    this.dialog.closeAll();
   }



   addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:"Portal",     
        officeID: this.officeID,
        organizationID: this.organizationID,
        portalEmail:this.portalEmail,
        cType:this.cType,
        transactionId:this.personID
      },
       panelClass: 'autoFill-modalbox'  
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){    
        this.selectPeoples(null);    
      } 
    });   
   }



//================== Signature ====================//
 

   closeSignature() {
    this.SignButtonEnable=false;
    this.DrawButtonEnable=false;
    this.reasonToDecline="";
    this.declineButtonShow=false;
    this.dialog.closeAll();
   }

  clearSignature(){
    this.SignButtonEnable=false;
    if(this.signaturePad!=undefined) {
    this.signaturePad.clear();
    }
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined) {
       var  context = canvas.getContext('2d');
      context.clearRect(0,0,canvas.width,canvas.height);
      context.beginPath();
     }
  }

    // Make signature default

    addDefaultSignature(){
      if(this.signatureID>0){
        //this.addSignatureAdopt();
      }
      var rqModel={
        signatureID: this.signatureID,
        email: this.portalEmail,
        isDefault: true
       }
      this.formsService.addDefaultSignature(rqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
             this.ShowAllSignature();
           }
          }
      });
      this.dialogueRef.close();
    }

    addSignature() {
      if(this.signatureID>0){
       // this.addSignatureAdopt();
      }else{
  
  let canvas = document.getElementsByTagName("canvas")[0]; 
  if(canvas!=undefined){
   this.signatureBase64=canvas.toDataURL();
   this.signName="";
   this.signOrInitialImageObj=[];
  }
  
   var signatureBase;
   var isDefault;
   var type;
   var obj;
  if(this.signatureBase64!=""){
     obj={
      type: "Draw",
      signatureBase64:this.signatureBase64,       
    }      
  }
  if(this.signOrInitialImageObj.length>0){
    obj={
      type: "Upload",
      ImageData:this.signOrInitialImageObj,    
    }         
  }
  if(this.signName!=""){      
     obj={
      type: "Type In",
      signatureText:this.signName,
      signInitialFontFamily:this.signInitialFontFamily
    }      
  } 
    var rqModel={
      signature: JSON.stringify(obj),
      email: this.portalEmail,
      isDefault: true
     }
    // return;
      this.formsService.addSignature(rqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
            this.ShowAllSignature();
           }
         }
      });
     }   
     this.dialogueRef.close();
    }  

    deleteSignature(signature) {
      const message = `Are you sure you want to delete this signature?`;
      const title = `Confirm Delete`;
      const confirm = `Delete`;
      const dialogData = new ConfirmDialogModel(title, message,confirm); 
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {          
            var reqModel={
              signatureID:signature.signatureID,
              email:this.portalEmail
            }         
            this.formsService.removeSignature(reqModel).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                 this.getAllSignatureInitialsAfterDelete();
                } else {
                 
                }
              } else {
               
              }
            });
          }
        } catch (e) {
          Observable.throw(e);
        }
      });
    }

    getAllSignatureInitialsAfterDelete(){
      var rqModel={       
        email: this.portalEmail,       
       }
       this.spinner=true;
       this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
        if (response != undefined) {
           this.responseHolder = response;
           this.spinner=false;
           if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
              
              this.getAllSignatures= this.responseHolder.data.signatures;            
          
              this.spinner=false;
  
              if(this.getAllSignatures.length>0){
                this.hasSignature = true;
                this.getAllSignatures.forEach(n => {              
                  n.signature=JSON.parse(n.signature);
                });
              }else{
                this.hasSignature = false;
              }                          
  
              if(this.getAllSignatures.length == 5){
                this.fiveSignaturesLimitReached=true;
              }
              else{
                this.fiveSignaturesLimitReached=false;
              }       
             
            }else{
              this.spinner=false;
            }
         }else{
          this.spinner=false;
         }
      });
    }

    selectedSignature(img:any){
      this.signatureID = img.signatureID;
      this.signatureData=img;
      this.getAllSignatures.forEach( x => {
        x.isDefault = (x.signatureID == this.signatureID) ? true : false;
      })
      this.SignButtonEnable = true;
    }

    setSignInitialFontFamilyChange(e:any) {
      this.signInitialFontFamily=e;
    }

    signOrInitialTextChanges(e:any) {
      if(this.signName!=='' && this.signName!==undefined) {
        this.SignButtonEnable=true;
        this.InitailButtonEnable=true;
        this.signatureBase64=''; 
        this.signOrInitialImageObj=[];  
     }else{
       this.SignButtonEnable=false;
       this.InitailButtonEnable=false;
     }
    }

    drawStart() {
      // will be notified of szimek/signature_pad's onBegin event   
    }

    drawComplete() {
      this.SignButtonEnable=true;
      this.DrawButtonEnable=true;
      this.InitailButtonEnable=true;
      // will be notified of szimek/signature_pad's onEnd event    
    }

    onSelectSignImage(event,data: any,id:any) {     
      var filename = event.target.files;
      for (let i = 0; i < filename.length; i++){
        var ext = filename[i].name.split('.').pop();
        if (ext.toUpperCase() != 'png'.toUpperCase() && ext.toUpperCase() != 'jpg'.toUpperCase() && ext.toUpperCase() != 'jpeg'.toUpperCase()) {
          alert('only image upload');
          return;
        }
        this.SignButtonEnable=true;
        this.InitailButtonEnable=true;
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          this.Imageurl = event.target.result;
          var FullPath = filename[i].name;
          var documentNameSplit = FullPath.split('.');
          var documentName = documentNameSplit[0];
          var documenttype = documentNameSplit[1];
          this.filenameForSign = documentName;
          var base64String = reader.result;       
                  
           this.signOrInitialImageObj.push({
            FileName: documentName,
            FileExtention: documenttype,
            FilePath:filename[i],
            Imageurl:base64String
          });    
       }  
      } 
    }

    signatureType(type:string){
      this.signOpt = type;
    }

    addNewSignature(){
      this.signatureID=0;
      this.hasSignature =  !this.hasSignature;
    }

    OpenSignPopup(templateRef: TemplateRef<any>) {          
      this.dialogueRef = this.dialog.open(templateRef, {
        panelClass: 'custom-modalboxSign'
       });
       return;           
     }

   getAllSignature(templateRef: TemplateRef<any>){
    var rqModel={       
      email: this.portalEmail,       
     }
     this.spinner=true;
     this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
         this.responseHolder = response;
         this.spinner=false;
         if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
            this.getAllSignatures = this.responseHolder.data.signatures;        
                 
            if(this.getAllSignatures.length>0){
              this.hasSignature = true;
              this.getAllSignatures.forEach(n => {    
                        
                n.signature=JSON.parse(n.signature);
              });
            }else{
              this.hasSignature = false;
            }           
          
            if(this.getAllSignatures.length == 5){
              this.fiveSignaturesLimitReached=true;
            }
            else{
              this.fiveSignaturesLimitReached=false;
            }

            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
             });
             return;  
             
          }else{
            this.spinner=false;
            this.dialogueRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalboxSign'
            });
            return;
          }
       }else{
        this.spinner=false;
        this.dialogueRef = this.dialog.open(templateRef, {
          panelClass: 'custom-modalboxSign'
        });
        return;
       }
    });
  }
    
  ShowAllSignature(){
    var rqModel={       
      email: this.portalEmail,       
     }
     this.spinner=true;
     this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
         this.responseHolder = response;
         this.spinner=false;
         if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
            this.getAllSignatures = this.responseHolder.data.signatures;        
          
            if(this.getAllSignatures.length>0){
              this.hasSignature = true;
              this.getAllSignatures.forEach(n => {                            
                n.signature=JSON.parse(n.signature);
              });
            }else{
              this.hasSignature = false;
            }            
          

            if(this.getAllSignatures.length == 5){
              this.fiveSignaturesLimitReached=true;
            }
            else{
              this.fiveSignaturesLimitReached=false;
            }          
           
            var checkSignDefault=[];
            checkSignDefault=this.responseHolder.data.signatures.filter(x=>x.isDefault==true);
             if(checkSignDefault.length>0){
           
              this.signatureID = this.signatureID;
              let sJson = checkSignDefault[0].signature;
          
              if(sJson.type=='Draw'){
                this.signatureBase64 = sJson.signatureBase64;
                this.signName="";
                this.signInitialFontFamily="";
                this.signOrInitialImageObj=[];
              }
              if(sJson.type=='Upload'){
                this.signatureBase64="";
                this.signName="";
                this.signInitialFontFamily="";
                this.signOrInitialImageObj=sJson.ImageData;
              }
              if(sJson.type=='Type In'){
                this.signatureBase64="";
                this.signName=sJson.signatureText;
                this.signInitialFontFamily=sJson.signInitialFontFamily;
                this.signOrInitialImageObj=[];
              }         
            }else{
            
            }  
          }else{           
          }
       }else{
        this.spinner=false;     
       }
    });
  }

  home(){
   
    // this.personID=0;
    // this.activities = [];
    // this.totalActivities= this.activities.length;

    // this.broadcastings = [];
    // this.totalBroadcastings= this.broadcastings.length;

    // this.contacts = [];
    // this.totalContacts= this.contacts.length;
    
    // this.forms = [];
    // this.totalForms= this.forms.length;

    // this.notesList  = [];
    // this.totalNotes = this.notesList.length;
    
    // this.waitingActions=  [];
    // this.totalWaitingActions= this.waitingActions.length;

    // this.selectedPersonId=null;
    this.getPortalDataforHome();
    this.getPortalFormsforHome();
  }

 

  isHome:boolean=false;
  addNotesForDashboard:boolean=true;
  currentNavigation  = 'home';
  
  showMenu(item:string){

   // this.selectedPersonId = "";

    if(item== "detail"){
      this.currentNavigation = "detail";
      if(this.personID>0){
        this.detail = true;
        this.isHome=true;
      }     
      this.isDashboard = false;        
      this.broadcastings = false;
      this.broadcastMessage =false;
      this.addNotesForDashboard =false;
      
      this.getCompletedActionsfor3C();
    }
    if(item== "broadcastMessage"){
      this.currentNavigation = "broadcastMessage";
      // if(this.personID>0){
      //  // this.detail = true;
      //   this.isHome=true;
      // }  
      this.isHome=false;
      this.broadcastMessage = true;
      this.isDashboard = false;
      this.detail = false;   
      this.addNotesForDashboard =false; 
      this.isHome = false;
     // this.isHome=false;     
      this.getPortalAllBroadcastingMessages();
    }
    if(item== "home"){
      this.currentNavigation = "home";
      this.isDashboard = true;
      this.broadcastMessage = false;  
      //window.location.reload();
      //return;
     // this.officeLogo=""; 
      //  if(this.personID>0){
      //   //this.isHome=true;
      //   this.addNotesForDashboard =false; 
      //  }else{
      //   //this.isHome=false;
      //   this.addNotesForDashboard =true; 
      //  }
      
       this.isHome=false;
       this.detail = false;       
      // this.addNotesForDashboard =true;   
       this.selectedPersonId = "";
       this.personID=0;
       this.backgroundImage="";  
       this.officeLogo=""; 
       this.home();
    }
    if(item== "dashboard"){
      this.currentNavigation = "dashboard";
      this.isDashboard = true;
      this.broadcastMessage = false;
      this.detail = false;    
      
      if(this.personID>0){ 
        this.addNotesForDashboard =false;     
        this.isHome=false;
        this.selectPeoples(null);
      } else{
        this.addNotesForDashboard =true; 
      }      
    }   
  }

  BroadcastMessage:string="";
  BroadcastofficeLogo:string="";
  BroadcastofficeName:string="";
  BroadcastorganizationName:string="";
  Broadcasttitle:string="";
  BroadcastDate:Date;

  showBroadcastDetails(data:any,templateRef: TemplateRef<any>) {
    //return;
    this.Broadcasttitle=data.title;
    this.BroadcastMessage=data.message;//.replace(/<[^>]*>/g, '');
    this.BroadcastofficeLogo=data.officeLogo;
    this.BroadcastofficeName=data.officeName;
    this.BroadcastorganizationName=data.organizationName;
    this.BroadcastDate = data.createdOn;
    this.dialogueRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalboxSign'
    });
    
    if(data.isRead==false){
      this.readNotification(data);
      this.getPortalBroadcastingMessages();
    }
  }

  closeBroadcast(){
    this.dialog.closeAll();
  }

  readNotification(data:any) {
    var ReqModel = {
      id: data.id,
      email: this.portalEmail,      
    }; 
    this.formsService.readNotification(ReqModel).subscribe((response) => {
      if(response != undefined) {
        this.ResponseHolderDetails = response;
        if(this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {   
       
        }else {
  
        }
      }
     });
   }

    
   DownloadFile(doc: any) {  
    this.spinner=true;
    this.formsService.getAttachment(doc.documentName, doc.documentURL).subscribe((response) => {
    if (response !== undefined) {
        const data = 'data:' + response.data.contentType +';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, doc.documentName);
        this.spinner=false;
       }else{
        this.spinner=false;
       }
    });
  }


  UploadedFilesDragZone:any=[]=[];
  formData: FormData;
  @ViewChild('Input') InputFile: ElementRef;
  
  selectFilesFromDragZone(event) {
    if(event.target.files.length>5){
      this.toastr.warning('Maximum 5 Document can be upload.', '', {
        timeOut: 3000,
      });
      return;
    }   
    this.loaderService.show();
    this.formData = new FormData();  
    this.UploadedFilesDragZone=[];
    this.UploadedFilesDragZone = event.target.files;
     
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {     
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });     
        this.InputFile.nativeElement.value = "";
        return;
      } 
      var documenttype="";
      var documentName="";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];          
        
      // if(documentNameSplit.length>2){
      //   this.toastr.warning('Please upload valid file name, or remove special character.', '', {
      //     timeOut: 3000,
      //   });
      //   this.InputFile.nativeElement.value = "";
      //   this.loaderService.hide(); 
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars
         
      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);     
    }  
    this.formData.append('TransactionID', (this.personID).toString());
    this.formData.append('OrganizationID', (this.organizationID).toString());
    this.formData.append('ByPortal', this.portalEmail);
    this.formData.append('OfficeID', (this.officeID).toString());  
   // this.formData.append('DatabaseID', this.databaseId);
    this.formsService.uploadCCCDocument(this.formData,this.cType).subscribe(response=>{
     if(response!=undefined){
          var responseHolder = response;
           this.loaderService.hide();
           this.UploadedFilesDragZone = [];
           if (responseHolder.status == this.statusConstant.statusSuccess) {                      
              this.toastr.success('File upload successfully.', '', {
               timeOut: 3000,
               });     
             }  
             if(this.detail==true){
              this.getCompletedActionsfor3C();
             }    
        }else{
          this.loaderService.hide(); 
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
        }
      });
  
    }


    replaceSelectedFiles(event,data:any) {
      // if(event.target.files.length>5){
      //   this.toastr.warning('Maximum 5 Document can be upload.', '', {
      //     timeOut: 3000,
      //   });
      //   return;
      // }   
      this.loaderService.show();
      this.formData = new FormData();  
      this.UploadedFilesDragZone=[];
      this.UploadedFilesDragZone = event.target.files;
       
      for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {     
        if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
          this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
            timeOut: 3000,
          });     
          this.InputFile.nativeElement.value = "";
          return;
        } 
        var documenttype="";
        var documentName="";
        var FullPath = this.UploadedFilesDragZone[i].name;
        var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
        var documentNameSplit = newfilename.split('.');
        documentName = documentNameSplit[0];
        documenttype = documentNameSplit[1];          
          
        // if(documentNameSplit.length>2){
        //   this.toastr.warning('Please upload valid file name, or remove special character.', '', {
        //     timeOut: 3000,
        //   });
        //   this.InputFile.nativeElement.value = "";
        //   this.loaderService.hide(); 
        //   return;
        // }
        //documentName = documentName.substring(0, 30);//get first 30 chars
           
        this.formData.append('file', this.UploadedFilesDragZone[i]);
       // this.formData.append('DocumentString', documentName + '|' + documenttype);
        this.formData.append('DocumentType', documenttype);
      }  
      this.formData.append('PlaceholderID', (data.placeholderID).toString());
      this.formData.append('DocumentID', (data.documentID).toString());     
      this.formData.append('OrganizationID', (this.organizationID).toString());
      this.formData.append('Byportal', this.portalEmail);
      this.formData.append('OfficeID', (this.officeID).toString());  
     // this.formData.append('DatabaseID', this.databaseId);
      this.formsService.replaceCCCDocumentPortal(this.formData,this.cType).subscribe(response=>{
       if(response!=undefined){
            var responseHolder = response;
             this.loaderService.hide();
             this.UploadedFilesDragZone = [];
             if(responseHolder.data == true && responseHolder.status == this.statusConstant.statusSuccess) { 
              this.getCompletedActionsfor3C();                 
              this.toastr.success('File replaced successfully.', '', {
                timeOut: 3000,
                });     
              }               
          }else{
            this.toastr.error('File Upload failed.', '', {
              timeOut: 3000,
            });
            this.UploadedFilesDragZone = [];
          }
        });
    
      }

    getIcon(type: number){
      let icon = "";
  
        switch(type){
          case 1: icon = "app_registration"
          break;
  
          case 2: icon = "contact_mail"
          break;
  
          case 3: icon = "business"
          break;
  
          case 4: icon = "pending_actions"
          break;
  
          case 5: icon = "work"
          break;
  
          case 6: icon = "border_color"
          break;
  
          case 7: icon = "task"
          break;
  
          case 8: icon = "task"
          break;
  
          case 9: icon = "border_color"
          break;
  
        }  
        return icon;
    }


    @Output() documentViewer = new EventEmitter<boolean>();
    
    getCloseDocumentViewer(_message: boolean) {    
      this.documentViewer.emit(false);
      this.dialog.closeAll();
    }

    documentPath:string="";
    fileType:string="";
    documentname:string="";
    
    openDocumentViewer(document,templateRef: TemplateRef<any>) {      
      this.documentPath =document.documentURL;
      this.fileType = document.fileType;
      this.documentname =document.documentName;
      this.documentViewer.emit(true);
      this.dialog.open(templateRef);
    }

    getTimeSpent(touch:any): any{
      if(touch.startDate && touch.endDate ){
   
       const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
   
       let startDate = new Date(touch.startDate).valueOf();
       let endDate = new Date(touch.endDate).valueOf();
       const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));
         
       if(diffDays){
          return `${diffDays}`
        }
        else{
         return "";
       }
     }
   }

   @Output() openChat = new EventEmitter<boolean>();
   showChatWindow = false;
   showChat:boolean = false;

    showChats() {
     this.showChat=true;
     this.openChat.emit(true);
   }

  getopenChatWindow(message:boolean){
    this.showChatWindow = message;
  }

  getChatclose(message:boolean){
    this.showChat = message;
  }

} 

